export default {
  datepicker: {
    invalid: 'Vul een geldige datum in (dd/mm/yyyy)',
    openPicker: 'Datumkiezer openen',
  },
  errorScreen: {
    actions: {
      callUs: 'Bel ons',
      createNewAppointment: 'Nieuwe afspraak maken',
      goBack: 'Sluiten',
    },
    header: 'Fout bij het boeken',
    messages: {
      default:
        'Er is een onverwachte fout opgetreden. Probeer het later opnieuw',
      internalServerError: 'Interne serverfout. Probeer het later opnieuw',
      network: 'Netwerkfout. Controleer uw verbinding en probeer het opnieuw.',
      noLocations: 'Geen locaties beschikbaar',
      timeffTimeoutVelthuis:
        'Op dit moment kunnen we geen afspraak voor je boeken. Bel ons of probeer het later nog een keer.',
      timeffTimeoutXpert:
        'Op dit moment kunnen we geen afspraak voor u boeken. Bel ons of probeer het later nog een keer.',
      zdCode: 'Ongeldige verwijzingscode',
    },
  },
  fields: {
    dateOfBirth: {
      error: 'Voer een geldige geboortedatum in',
      label: 'Geboortedatum',
      placeholder: 'DD/MM/YYYY',
    },
    email: {
      error: 'Voer een geldig e-mailadres in',
      label: 'E-mailadres',
      placeholder: 'john.doe@mail.com',
    },
    firstName: {
      error: 'Voer uw voornaam in',
      label: 'Voornaam',
      placeholder: 'John',
    },
    gender: {
      error: 'Selecteer uw geslacht',
      label: 'Geslacht',
      options: {
        female: 'Vrouw',
        male: 'Man',
        other: 'Anders',
        unknown: 'Onbekend',
      },
    },
    height: {
      error: 'Voer een geldige lengte in',
      label: 'Lengte (cm)',
    },
    houseNumber: {
      error: 'Voer uw huisnummer in',
      label: 'Huisnummer',
      placeholder: '12a',
    },
    initials: {
      error: 'Voer uw voorletters in',
      label: 'Voorletters',
      placeholder: 'JD',
    },
    lastName: {
      error: 'Voer uw achternaam in',
      label: 'Achternaam',
      placeholder: 'Doe',
    },
    phone: {
      error: 'Voer een geldig telefoonnummer in',
      label: 'Telefoonnummer',
      placeholder: 'XXX-XXX XXXX',
    },
    postalCode: {
      error: 'Voer een geldige postcode in',
      label: 'Postcode',
      placeholder: '1234 AB',
    },
    weight: {
      error: 'Voer een geldig gewicht in',
      label: 'Gewicht (kg)',
    },
  },
  navHeader: 'Maak een afspraak',
  successScreen: {
    actions: {
      close: 'Sluiten',
    },
    header: 'Afspraak bevestigd',
  },
}
